import { forwardRef } from 'react'

import { Link } from 'react-router-dom'

const SearchLink = forwardRef((props, ref) => {
  // peeling off props that react-router yells about
  const { isSelected, ...rest } = props
  return <Link {...rest} ref={ref} />
})

SearchLink.displayName = 'SearchLink'

export default SearchLink
